/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterRoleDto } from '../../models/center-role-dto';
import { CreateCenterRoleDto } from '../../models/create-center-role-dto';

export interface CenterRoleControllerCreateRole$Params {
  id: string;
      body: CreateCenterRoleDto
}

export function centerRoleControllerCreateRole(http: HttpClient, rootUrl: string, params: CenterRoleControllerCreateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterRoleDto>> {
  const rb = new RequestBuilder(rootUrl, centerRoleControllerCreateRole.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterRoleDto>;
    })
  );
}

centerRoleControllerCreateRole.PATH = '/api/center-role/{id}/roles';
